const e = () => typeof window > "u" ? !1 : !!("ontouchstart" in window || navigator.maxTouchPoints > 0 || (navigator.msMaxTouchPoints ?? 0) > 0 || /\b(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)\b/i.test(
  navigator.userAgent
));
export {
  e as isTouchDevice
};
